var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isMobile)?_c('taverns-page',{ref:"taverns",on:{"path":_vm.pathChange,"openDetail":_vm.openDetail}}):_vm._e(),_vm._v(" "),_c('detail-dialog',{attrs:{"ldbId":_vm.detailInfo._id},on:{"close":_vm.dialogClose},model:{value:(_vm.detailModel),callback:function ($$v) {_vm.detailModel=$$v},expression:"detailModel"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15141b86","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/taverns/index.vue
// module id = null
// module chunks = 